import { createCRUDHook } from './createCRUDHook';
import { PartAssemblyManufactureDto } from 'utils/models';
import { TBL_PART_ASSEMBLY_MANUFACTURE } from './apiEndPoints';

const { Context, useManager, useConsumer } =
  createCRUDHook<PartAssemblyManufactureDto>({
    entityName: 'PartAssemblyManufacture',
    endpoint: TBL_PART_ASSEMBLY_MANUFACTURE,
  });

export const PartAssemblyManufactureContext = Context;
export const usePartAssemblyManufactureManager = useManager;
export const usePartAssemblyManufacture = useConsumer;
